<template>
    <v-container fill-height>
        <v-row justify="center" align="center">
            <v-col cols="12" xl="4" lg="5" md="6">
                <v-img class="mx-auto ml-md-0" src="/images/neumann-logo.png" width="250"></v-img>
                <p class="mt-6 mb-0 subtitle text-center text-md-left">Aprende un nuevo idioma de una manera fácil, cómoda y divertida.</p>
            </v-col>
            <v-col cols="12" xl="3" lg="4" md="6">
                <v-card :loading="loading" :disabled="loading">
                    <v-card-text>
                        <v-form v-model="form" ref="login" v-on:submit.prevent="submit">
                            <v-text-field
                                type="email"
                                @keydown.space.prevent
                                v-model.trim="email"
                                :rules="[rules.required, rules.email]"
                                color="#008DD4"
                                name="email"
                                outlined
                                clearable
                                placeholder="Correo electrónico"
                            ></v-text-field>
                            <v-text-field
                                :type="show_password ? 'text' : 'password'"
                                :append-icon="show_password ? 'mdi-eye' : 'mdi-eye-off'"
                                v-model="password"
                                :rules="[rules.required]"
                                color="#008DD4"
                                name="password"
                                outlined
                                placeholder="Contraseña"
                                @click:append="show_password = !show_password"
                            ></v-text-field>
                            <v-btn type="submit" block color="#008DD4" x-large dark :loading="loading">Entrar</v-btn>
                        </v-form>
                        <v-divider class="my-7"></v-divider>
                        <v-btn href="/register" block color="success" x-large>Registrate</v-btn>
                    </v-card-text>
                </v-card>

                <v-card class="mt-3">
                    <v-card-text class="py-0">
                        <v-col class="text-center">
                            <email></email>
                        </v-col>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<style>
    @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@500&display=swap');

    .v-application--wrap{
        background-color: #f5f5f5;
    }
    .subtitle{
       font-size: 30px;
       font-family: 'Poppins', sans-serif;
       color: #008DD4;
    }

    @media (max-width: 600px) {
        .subtitle{
            font-size: 15px;
        }
    }
</style>

<script>

import email from './email'
import iziToast from 'izitoast'

export default {
    components:{
        email
    },
    data: () => ({
        //URLS
        img: "/images/welcome.png",
        login:"/login",

        //booleans
        form:false,
        show_password:false,
        loading:false,

        color: "#000",

        //Rules
        rules:{
            required: v => !!v || 'El campo es requerido',
            email: v => /^[^@]+@[^@]+\.[a-zA-Z]{2,}$/.test(v) || 'El Correo electrónico ingresado no es válido'
        },

        //Models
        email:"",
        password:"",
    }),

    methods: {
        submit:function(event){
            this.email = this.email.trim()
            this.$refs.login.validate()
            if(this.form){
                this.loading = true
                axios.post(this.login, { email: this.email, password: this.password}).then(response => {
                    this.loading = false
                    location.replace('/home')

                }).catch(error => {
                    this.loading = false
                    if(error.response.data.disable){
                        iziToast.error({
                            position:"topRight",
                            message:"<strong>Error</strong><br>Tu cuenta ha sido temporalmente suspendida<br>por demaciados intentos de inicio de sesión"
                        })
                    }else if(error.response.data.disabled){
                        iziToast.error({
                            position:"topRight",
                            message:"<strong>Error</strong><br>Tu cuenta está suspendida. Contacte al Administrador."
                        })
                    }
                    else{
                        iziToast.error({
                            title:"Error",
                            position:"topRight",
                            message:"Usuario y/o contraseña incorrectos"
                        })
                    }

                })
            }
        }
    },
}
</script>
